import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as artifactActions from '~/artifact/actions';
import ArtifactViewMainContentSignaturesComponentVersionDetailsHeader from '~/artifact/containers/ArtifactViewMainContentSignaturesComponentVersionDetailsHeader';
import ArtifactViewMainContentSignaturesComponentVersionDetailsCoordinates from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionDetailsCoordinates';
import ArtifactViewMainContentSignaturesComponentVersionDetailsBytecodeHashes from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionDetailsBytecodeHashes';
import ArtifactViewMainContentSignaturesComponentVersionDetailsFileHashes from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionDetailsFileHashes';
const SECTION = 'signatures';
type ArtifactViewMainContentSignaturesComponentVersionDetailsProps = {
  actions: object;
  artifactState: object;
};
class ArtifactViewMainContentSignaturesComponentVersionDetails extends React.Component<
  ArtifactViewMainContentSignaturesComponentVersionDetailsProps,
  {}
> {
  constructor(props, context) {
    super(props, context);
  }
  componentDidMount() {
    let store = this.props.artifactState,
      components = store.affectedComponents || [],
      activeComponentId = store.componentId,
      activeComponent =
        _.find(components, function(component) {
          return component.id === activeComponentId;
        }) || {};
    this.props.actions.updateComponentPackageManager(activeComponent.coordinateType || '', SECTION);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    let oldStore = this.props.artifactState,
      oldComponents = oldStore.affectedComponents || [],
      oldActiveComponentId = oldStore.componentId,
      oldActiveComponent =
        _.find(oldComponents, function(component) {
          return component.id === oldActiveComponentId;
        }) || {},
      newStore = nextProps.artifactState,
      newComponents = newStore.affectedComponents || [],
      newActiveComponentId = newStore.componentId,
      newActiveComponent =
        _.find(newComponents, function(component) {
          return component.id === newActiveComponentId;
        }) || {};
    if (
      newActiveComponent.coordinateType &&
      oldActiveComponent.coordinateType !== newActiveComponent.coordinateType
    ) {
      this.props.actions.updateComponentPackageManager(
        newActiveComponent.coordinateType || '',
        SECTION
      );
    }
  }
  render() {
    let store = this.props.artifactState,
      components = store.affectedComponents,
      activeComponentId = store.componentId,
      activeComponent =
        _.find(components, function(component) {
          return component.id === activeComponentId;
        }) || {},
      activeVersion = store.componentVersion,
      activeSection = store.signatureSection,
      activeManager = store.signaturesComponentPackageManager,
      fullVersion = {},
      headerElements = [],
      bodyElement;
    if (!_.isEmpty(activeComponent) && activeVersion) {
      fullVersion =
        _.find(activeComponent.versions, function(version) {
          return version.version === activeVersion;
        }) || {};
    }
    headerElements.push(
      <div className="inline-block pl phone--col-1-1 phone--pl0" key="coords">
        <ArtifactViewMainContentSignaturesComponentVersionDetailsHeader
          text="Coordinates"
          section="coordinates"
          activeSection={activeSection}
        />
      </div>
    );
    if (fullVersion.bytecodeHash) {
      headerElements.push(
        <div className="inline-block pl+ phone--col-1-1 phone--pl0" key="byte">
          <ArtifactViewMainContentSignaturesComponentVersionDetailsHeader
            text="Bytecode Hashes"
            section="bytecode-hashes"
            activeSection={activeSection}
          />
        </div>
      );
    }
    headerElements.push(
      <div className="inline-block pl+ phone--col-1-1 phone--pl0" key="file">
        <ArtifactViewMainContentSignaturesComponentVersionDetailsHeader
          text="File hashes"
          section="file-hashes"
          activeSection={activeSection}
        />
      </div>
    );
    if (activeSection === 'coordinates') {
      bodyElement = (
        <ArtifactViewMainContentSignaturesComponentVersionDetailsCoordinates
          component={activeComponent}
          version={fullVersion}
          activeManager={activeManager}
        />
      );
    } else if (activeSection === 'bytecode-hashes') {
      bodyElement = (
        <ArtifactViewMainContentSignaturesComponentVersionDetailsBytecodeHashes
          version={fullVersion}
        />
      );
    } else if (activeSection === 'file-hashes') {
      bodyElement = (
        <ArtifactViewMainContentSignaturesComponentVersionDetailsFileHashes version={fullVersion} />
      );
    }
    return (
      <div className="grid ph flex phone--grid--full">
        {headerElements}
        <div className="inline-block col-1-1 pl phone--pl0">{bodyElement}</div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentSignaturesComponentVersionDetails);
